import { HiOutlineLocationMarker } from "react-icons/hi";
import "./adres.css";
import Seo from "../../components/seo/Seo";
import { locations } from "../../data/siteContent";

export default function Adres() {
    return (
        <>
            <Seo
                title="Diëtist op meerdere locaties in Breda"
                description="Bekijk de spreekuurlocaties van diëtistenpraktijk Vandaag Begin Ik in Breda en plan een afspraak op een passende plek."
                path="/adres"
            />

            <section className="page-intro">
                <p className="section-label">Locaties</p>
                <h1>Spreekuren op meerdere locaties in Breda.</h1>
                <p>
                    U bent van harte uitgenodigd voor een afspraak met de diëtist op een van onderstaande
                    locaties in Breda.
                </p>
                <p>
                    Indien medisch noodzakelijk kunnen er op dinsdagmiddag en vrijdag huisbezoeken
                    worden ingepland.
                </p>
            </section>

            <section className="locations-grid">
                {locations.map((location) => (
                    <article className="location-card" key={location.street}>
                        <div className="location-card__icon">
                            <HiOutlineLocationMarker />
                        </div>
                        <div>
                            <h2>{location.title}</h2>
                            <p>{location.street}</p>
                            <p>{location.city}</p>
                        </div>
                    </article>
                ))}
            </section>
        </>
    );
}
